import { render } from "./IconLocation.vue?vue&type=template&id=3d1713f8"
import script from "./IconLocation.vue?vue&type=script&lang=js"
export * from "./IconLocation.vue?vue&type=script&lang=js"
script.render = render

export default script